module.exports = __webpack_public_path__ + "static/media/FBwithround.1c4b2f39.svg";